import {OpportunityAction} from "../../model/OpportunityAction";
import './opportunities_actions_log.scss';

export class OpportunitiesActionsLog implements ng.IComponentController {


    public static instance: ng.IComponentOptions = {
        template: require('./OpportunitiesActionsLog.html'),
        controller: [OpportunitiesActionsLog],
        bindings: {
            'opportunityActions': '<'
        }
    };

    private opportunityActions: OpportunityAction[];

}